import React, { useCallback, ComponentProps } from 'react';
import { PaymentSource } from '../../constants';
import { PayPalButton } from '../PaymentSourceButton';
import { useOrderDetails } from '../OrderDetails';
import { useOrderDetailsPaymentSource } from './useOrderDetailsPaymentSource';

type Props = Omit<ComponentProps<typeof PayPalButton>, 'paypalClientToken' | 'onSelect'>;

export const usePayPalSupported = () => {
  const { orderSummary } = useOrderDetails();

  return orderSummary?.attributes.isPayPalSupported;
};

export const OrderDetailsPayPalButton: React.FC<Props> = props => {
  const { orderSummary } = useOrderDetails();
  const isPayPalSupported = usePayPalSupported();
  const { changePaymentSource, selectLatestAddress } = useOrderDetailsPaymentSource();

  const onSelect = useCallback(async () => {
    await changePaymentSource(PaymentSource.PayPal);
    await selectLatestAddress();
  }, [changePaymentSource, selectLatestAddress]);

  if (!isPayPalSupported || !orderSummary) return null;

  const { paypalClientToken } = orderSummary.attributes;

  return <PayPalButton {...props} paypalClientToken={paypalClientToken} onSelect={onSelect} />;
};
